import React from 'react';
class InfoLabel extends React.Component {
    render() {
        return (
            <div className="flex items-center text-primary-dark bg-primary-lighter p-3 mb-2 uppercase">
                <div className="text-xl">
                    {this.props.label}
                </div>
            </div>
        )
    }
}

export default InfoLabel;